import { world } from '../languages';
import { AVAILABLE_WORLDS } from '../languages/constants';

const METRICS_WORLDS: string[] = [
    AVAILABLE_WORLDS.DE,
    AVAILABLE_WORLDS.ES,
    AVAILABLE_WORLDS.IT,
    AVAILABLE_WORLDS.GR,
    AVAILABLE_WORLDS.NL
];

export const isMetricsWorld = (): boolean => METRICS_WORLDS.includes(world);

export const isWorldWithEnabledAuthorMetrics = (countryCode: string): boolean => {
    if (world === AVAILABLE_WORLDS.ES && countryCode !== 'ES') {
        return false;
    }

    return isMetricsWorld();
};
